import React, {
  ReactNode,
  MouseEvent,
  useCallback,
  CSSProperties
} from 'react';
import { GADataType } from '../../../types';

type ButtonHelperOnClick = (e: MouseEvent<HTMLButtonElement>) => void;

interface ButtonHelperProps {
  blurOnMouseLeave?: boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: ButtonHelperOnClick;
  onMouseEnter?: () => void;
  style?: CSSProperties;
}

function ButtonHelper({
  blurOnMouseLeave,
  children,
  className,
  dataGa,
  disabled,
  onClick,
  onMouseEnter,
  style
}: ButtonHelperProps & GADataType) {
  const handleClick = useCallback<ButtonHelperOnClick>(
    (e) => {
      e.preventDefault();
      onClick?.(e);
    },
    [onClick]
  );

  const handleMouseLeave = useCallback(
    (event) => (event.target as HTMLButtonElement)?.blur(),
    []
  );

  return (
    <button
      className={className}
      data-ga={dataGa}
      disabled={disabled}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={blurOnMouseLeave ? handleMouseLeave : undefined}
      style={style}
      type="button"
    >
      {children}
    </button>
  );
}

export default ButtonHelper;
